export default __webpack_public_path__ + "static/media/content_tab01_05.6c07f7d2.jpg";